import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatNotification } from './modules/mat-notifications/mat-notifications.module';
import { Me } from './services/me.service';

@Injectable({ providedIn: 'root' })
export class HttpErrorInterceptor implements HttpInterceptor {

	constructor(private me: Me,
				private dialog: MatDialog,
				private notification: MatNotification) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		let hasIgnoreErrorNotifications: boolean = false;

		if(hasIgnoreErrorNotifications = request.params.has('ignoreErrorNotifications'))
			request = request.clone({ params: request.params.delete('ignoreErrorNotifications') });

		return next
				.handle(request)
				.pipe(
					catchError((errorResponse: HttpErrorResponse) => {

						if(!navigator.onLine)
							return of(null);

						let error: any;

						if(errorResponse?.error?.error)
							error = errorResponse.error.error;
						else if (errorResponse?.error instanceof ErrorEvent)
							error = errorResponse.error;
						else
							error = errorResponse;

						if (error.message && typeof error.message !== 'string')
							error.message = error.message.flatDeep().join('\n');

						if(error.code === 404 && !error.message)
							error.message = `Route ${request.method} ${request.url} introuvable`;

						else if(error.code === 401 && error.token) {
							hasIgnoreErrorNotifications = true;
							this.me.update.next(error);
						}

						if(error.trace)
							console.error(`${error.message}\r\n${error.trace}`);

						if(!hasIgnoreErrorNotifications) {
							this.dialog.closeAll();
							this.notification.open({
								type: 'warn',
								title: `Echec`,
								message: error.message,
								canClose: true
							});
						}

						return throwError(() => error);
					})
				);
	}
}